/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import React from "react";
import { FormLabel, TextField as MuiTextField, TextField } from "@mui/material";
import "./TextInputField.scss";

/**
 * Text input field
 * @returns input entered
 */
interface IProps {
  fieldLabel?: string;
  id: string;
  type: string;
  required?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  error?: boolean;
  helperText?: string;
  value?: any;
  disabled?: boolean;
  labelFontSize?: string;
  marginBottom?: string;
  dataTestId?: string;
  styleName?: string;
}

const TextInputField = (props: IProps) => {
  return (
    <>
      <FormLabel
        required={props.required}
        sx={{ fontSize: props.labelFontSize ? props.labelFontSize : "0.8rem" }}
        className="text-input-label"
      >
        {props.fieldLabel}
      </FormLabel>
      <MuiTextField
        disabled={props.disabled}
        error={props.error}
        helperText={props.helperText}
        className={props.styleName}
        id={props.id}
        value={props.value}
        type={props.type}
        size="small"
        placeholder={props.placeholder}
        fullWidth={true}
        onChange={(e) => {
          const value = e.target.value;
          if (value.length > 31 && props.id.toLowerCase().includes("name")) {
            e.target.value = value.slice(0, 31); // Truncate the value to 5 characters
          }
          props.onChange && props.onChange(e.target.value);
        }}
        sx={{
          marginBottom: props.marginBottom ? props.marginBottom : "3vh",
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#F0F0F0",
          },
          "& .MuiFormHelperText-root": {
            marginLeft: "0",
          },
        }}
        inputProps={{ "data-testid": props.dataTestId }}
      />
    </>
  );
};

export default TextInputField;
